import { api } from '@/core/api/';
// const API_URL = 'api/compensatoryrequest/';

export const compensatoryRequestSearchInitFilters = () =>
  api.get(`api/compensatoryrequest/initfilters`);

export const compensatoryRequestSearch = (filters, pageSize, currentPage) =>
  api.post(`api/compensatoryrequest/search?`, filters, {
    params: {
      pageSize: pageSize,
      currentPage: currentPage,
    },
  });

export const getCompensatoryApprovementReasons = () =>
  api.get(`api/compensatoryrequest/compensatoryServiceApprovementReasons`);

export const updateDueInterventions = (id, visitDue) =>
  api.put(
    `api/compensatoryrequest/DueInterventions?id=${id}&visitDue=${visitDue}`
  );

export const getCompensatoryRequestInterventions = (id) =>
  api.get(`api/compensatoryrequest/interventions/${id}`);

export const submitClosingAnalysis = (id, data) => {
  return api.put(`api/compensatoryrequest/submitClosingAnalysis/${id}`, data);
};

export const getCompensatoryRequestAnalysisData = (id) =>
  api.get(`api/compensatoryrequest/replacement/${id}`);

export const getCompensatoryRequestReplacementStrategies = (replacementId) =>
  api.get(`api/compensatoryrequest/replacementstrategies/${replacementId}`);

export const getCompensatoryDocumentTypes = (compensatoryRequestId) =>
  api.get(`api/compensatoryrequest/documentTypes/${compensatoryRequestId}`);

export const replacementDocumentUpload = (params) =>
  api.post('api/compensatoryrequest/replacement/documentUpload', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const deleteCompensatoryDocument = (params) =>
  api.post('api/compensatoryrequest/documentDelete', params);

export const completeReplacement = (payload) =>
  api.put('api/compensatoryrequest/replacement', payload);

export const compensatoryreferralSearch = (filters, pageSize, currentPage) =>
  api.get(`api/compensatoryreferral/search?`, {
    params: {
      ...filters,
      currentPage: currentPage,
      pageSize: pageSize,
    },
  });

export const resetReplacement = (compensatoryRequestId) =>
  api.put(`api/compensatoryrequest/resetReplacement/${compensatoryRequestId}`);

export const saveAdmission = (params) =>
  api.post('api/compensatoryreferral/saveAdmission', params);

export const getCompesatoryRepositionAbsence = () =>
  api.get('api/compensatoryrequest/compensatoryrepositionabsence');

export const getCompensatoryRequestReplacementCommentsStrategies = (
  replacementId
) =>
  api.get(
    `api/compensatoryrequest/replacementcommentstrategies/${replacementId}`
  );

export const getStudentServices = (compensatoryRequestType, search) =>
  api.get(
    `api/compensatoryrequest/studentservices/${compensatoryRequestType}/${search}`
  );

export const getVisits = (admissionId, requestType) =>
  api.get(`api/compensatoryrequest/getvisits/${admissionId}/${requestType}`);

export const getCompensatoryRequestStudentService = (params) =>
  api.get('api/compensatoryrequest/request', { params: params });

export const getEducationalCompensatoryRequest = (id) =>
  api.get(`api/compensatoryrequest/educationalrequest/${id}`);

export const saveCompensatoryRequest = (params) =>
  api.post('api/compensatoryrequest/saveCompensatoryRequest', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const rejectCompensatoryRequest = (params) =>
  api.post('api/compensatoryrequest/reject', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const saveReferralItemAttachment = (params) =>
  api.post('api/compensatoryrequest/savereferralitemattachment', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getReferralDocumentsByStudentService = (
  payload,
  currentPage,
  pageSize
) =>
  api.get(`api/compensatoryrequest/referral/documents`, {
    params: {
      ...payload,
      currentPage: currentPage,
      pageSize: pageSize,
    },
  });

export const getEducationalDocumentsByRequest = (id, currentPage, pageSize) =>
  api.get(`api/compensatoryrequest/educational/documents`, {
    params: {
      id: id,
      currentPage: currentPage,
      pageSize: pageSize,
    },
  });

//Determination Endpoints

export const getDeterminationReasons = () =>
  api.get(`api/compensatoryrequest/reasons`);
export const isInterventionAreApproved = (requestId) =>
  api.get(`api/compensatoryrequest/interventionAreApproved/${requestId}`);
export const submitDetermination = ({
  requestId,
  statusId,
  reasonId,
  comment,
}) =>
  api.put(`api/compensatoryrequest/${requestId}/Determination/${statusId}`, {
    reasonId,
    comment,
  });

export const submitIntervention = (item) => {
  return api.post(`api/compensatoryrequest/replacement/interventionsDue`, item);
};

export const getCompensatoryRequestRejectReasons = () =>
  api.get('api/compensatoryrequest/rejectreasons');

export const updateRequestStatusToPrevious = (id) =>
  api.put(`api/compensatoryrequest/changerequeststatustoprevious/${id}`);

export const updateCompensatoryRequestStatus = (payload) =>
  api.put(`api/compensatoryrequest/updatecompensatoryrequeststatus`, payload);

export const getStatusHistory = (id, pageSize, currentPage, isEducational) =>
  api.get(
    `api/compensatoryrequest/statusHistory/${id}?pageSize=${pageSize}&currentpage=${currentPage}&isEducational=${isEducational}`
  );

export const getForm = async (id, isEducational) => {
  return await api.get(
    `api/report/compensatoryrequest/form/${id}?isEducational=${isEducational}`
  );
};

export const getCompensatoryRequestGeneralInfo = async (id) => {
  return await api.get(`api/compensatoryrequest/generalinfo/${id}`);
};

export const updateCompensatoryServiceBalance = (params) => {
  return api.post(
    'api/compensatoryrequest/updatecompensatoryservicebalance',
    params
  );
};

export const deleteCompensatoryRequest = async (id) => {
  return await api.delete(`api/compensatoryrequest/delete/${id}`);
};

export const replaceDocument = async (documentId, payload) => {
  return await api.put(
    `api/compensatoryrequest/replacedocument/${documentId}`,
    payload
  );
};
